import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/(private)/layout.tsx")